export const state = {
  reports: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/reports/state.js